import { apiClient } from '../../config/axios-client'
import type {
  AcceptedPlaygroundGeneration,
  PlaygroundGeneration,
  PlaygroundGenerationRequest,
} from '../../shared/models/PlaygroundGeneration'
import type { WorkspaceItem } from '../../shared/models/WorkspaceItem'

const basePath = (workspaceId: string) => `workspaces/${workspaceId}/playgrounds/image`
const playgroundBasePath = (workspaceId: string) => `workspaces/${workspaceId}/playgrounds`

export const playgroundsApi = {
  images: (workspaceId: string) =>
    apiClient.get<WorkspaceItem[]>(`${basePath(workspaceId)}/images`),
  referenceFolder: (workspaceId: string) =>
    apiClient.post<{ parentId: string }>(`${playgroundBasePath(workspaceId)}/reference-folder`),
  generate: (workspaceId: string, request: PlaygroundGenerationRequest) =>
    apiClient.post<AcceptedPlaygroundGeneration>(`${basePath(workspaceId)}/generations`, request),
  active: (workspaceId: string) =>
    apiClient.get<PlaygroundGeneration[]>(`${basePath(workspaceId)}/generations`),
  status: (workspaceId: string, activityId: string) =>
    apiClient.get<PlaygroundGeneration>(`${basePath(workspaceId)}/generations/${activityId}`),
}
